import React, { useEffect, useState } from 'react';
import { ReactComponent as Star } from '../../../../assets/svgs/star.svg';
import Typo from '../../../../components/atom/Typo';
import colors from '../../../../constants/colors.constants';
import ReviewQuestionProfile from './ReviewQuestionProfile';
import strings from '../../../../constants/strings.constants';
import TextArea from '../../../../components/atom/TextArea';

export interface ReviewRatingWithTextInputProps {
  value:
    | {
        rating: number;
        comment: string;
      }
    | undefined;
  onChange?: (value: { rating: number; comment: string }) => void;
  maxScore?: number;
  label?: string;
  profileInfo?: {
    name: string;
    imageUrl?: string;
    treatmentCategory?: string;
  };
}

function ReviewRatingWithTextInput(props: ReviewRatingWithTextInputProps) {
  const { label = '', value, onChange, maxScore = 5, profileInfo } = props;
  const [stars, setStars] = useState<
    {
      selected: boolean;
      score: number;
    }[]
  >([]);
  const [comment, setComment] = useState<string>('');

  useEffect(() => {
    const stars = [];
    for (let i = 0; i < maxScore; i += 1) {
      const score = i + 1;
      stars.push({
        score,
        selected: false,
      });
    }
    setStars(stars);
  }, [maxScore]);

  useEffect(() => {
    if (value) {
      const stars = [];
      for (let i = 0; i < maxScore; i += 1) {
        const score = i + 1;
        stars.push({
          score,
          selected: value.rating >= score,
        });
      }
      setStars(stars);
      setComment(value.comment || '');
    }
  }, [value, maxScore]);

  return (
    <div className="flex flex-col gap-2">
      <div className="text-center flex flex-col gap-3">
        {profileInfo && (
          <ReviewQuestionProfile
            name={profileInfo.name}
            imageUrl={profileInfo.imageUrl}
            treatmentCategory={profileInfo.treatmentCategory}
          />
        )}
        <Typo
          type="m-16"
          style={{
            lineHeight: 1.3,
          }}
        >
          {label}
        </Typo>
      </div>
      <div className="flex justify-center">
        <div className="flex gap-2">
          {stars.map(({ score, selected }) => {
            return (
              <Star
                key={score}
                style={{
                  color: selected ? colors.btnStar : colors.btnDisabledStar,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (onChange) {
                    onChange({ rating: score, comment });
                  }
                }}
              />
            );
          })}
        </div>
      </div>
      <TextArea
        style={{
          marginTop: 8,
        }}
        placeholder={strings.reviewCommentPlaceholder}
        value={comment}
        onChange={(value) => {
          if (onChange) {
            onChange({
              rating: stars.find(({ selected }) => selected)?.score || 0,
              comment: value,
            });
          }
        }}
      />
    </div>
  );
}

export default ReviewRatingWithTextInput;
